import { useEffect, useState } from "react";

/** Subscribe to the global currency mode toggle (USD/GBP/INR/"" for all). */
export function useCurrencyMode() {
  const [mode, setMode] = useState(() => localStorage.getItem("currencyMode") || "");
  useEffect(() => {
    const h = (e) => setMode(e.detail || "");
    window.addEventListener("currencyModeChange", h);
    return () => window.removeEventListener("currencyModeChange", h);
  }, []);
  return mode;
}
